/* Evoke – screen printing minimum across the whole order.
   Garments with the same logo (file), position, number of colours and Pantone ink count together towards
   the 10-garment minimum, even when they're different products. Used on the product page and the cart. */
(function () {
  'use strict';
  function norm(s) { return (s || '').toString().toLowerCase().replace(/pantone|pms/g, '').replace(/[^a-z0-9,]+/g, ''); }
  function method(vt) {
    vt = (vt || '').toString().toLowerCase();
    if (!vt || vt.indexOf('none') >= 0) return '';
    if (vt.indexOf('screen') >= 0 || /\d[ -]col/.test(vt)) return 'screen';
    if (vt.indexOf('embroid') >= 0) return 'embroidery';
    if (vt.indexOf('dtg') >= 0 || vt.indexOf('dtf') >= 0 || vt.indexOf('full colour') >= 0 || vt.indexOf('full color') >= 0) return 'dtf';
    return 'other';
  }
  function type(vt) { return ((vt || '') + '').split(' / ')[0].trim(); }
  function isSize(k, v) { return k.indexOf(':') > 0 && /^\d+$/.test((v + '').trim()); }
  /* Pantone per ink colourway: "PMS 286 C" or "Ink 1: PMS 286 C; Ink 2: White" */
  function inkPantones(pms, cw) {
    pms = (pms || '') + '';
    if (!cw || cw < 2) return [norm(pms)];
    var out = [];
    for (var i = 1; i <= cw; i++) { var m = pms.match(new RegExp('Ink ' + i + ':\\s*([^;]*)')); out.push(norm(m ? m[1] : '')); }
    return out;
  }
  /* "Ink 1 - Navy, Black; Ink 2 - White" -> { Navy: 1, Black: 1, White: 2 } */
  function inkOf(map) {
    var o = {};
    ((map || '') + '').split('; ').forEach(function (g) {
      var m = g.match(/^Ink (\d+) - (.*)$/);
      if (m && m[2] !== 'none') m[2].split(', ').forEach(function (c) { o[c.trim()] = parseInt(m[1], 10); });
    });
    return o;
  }
  /* order text is saved as plain text (xo-plain.js), so compare plain versions of file names and Pantones */
  function P(x) { x = x || ''; return window.xoPlain ? window.xoPlain.text(x) : x; }
  function unitKey(loc, file, typ, pan) { return [loc, P(file).toLowerCase(), typ, P(pan)].join('|'); }
  function colourQty(props) {
    var o = {};
    Object.keys(props || {}).forEach(function (k) { if (isSize(k, props[k])) { var c = k.split(':')[0].trim(); o[c] = (o[c] || 0) + parseInt(props[k], 10); } });
    return o;
  }
  /* cart.js items grouped into batches (garment + branding + setups sharing a Lot) */
  function batches(items) {
    var lots = {}, order = [];
    (items || []).forEach(function (it) {
      var p = it.properties || {}, lot = p.Lot;
      if (!lot) return;
      if (!lots[lot]) { lots[lot] = { lot: lot, garment: null, branding: [], setups: [], fees: [], names: null, all: [] }; order.push(lot); }
      var b = lots[lot];
      b.all.push(it);
      if (it.handle.indexOf('decoration-') === 0) b.branding.push(it);
      else if (it.handle === 'screen-print-colour-change-fee') b.fees.push(it);
      else if (it.handle === 'name-embroidery') b.names = it;
      else if (p.For !== undefined || /setup|redraw/.test(it.handle)) b.setups.push(it);
      else if (!b.garment) b.garment = it;
    });
    return order.map(function (l) { return lots[l]; }).filter(function (b) { return b.garment; });
  }
  function fileFor(props, loc) {
    var f = '';
    Object.keys(props || {}).forEach(function (k) { if (!f && k.indexOf(loc + ': ') === 0 && /\/uploads\//.test(props[k] + '')) f = k.slice(loc.length + 2); });
    return f;
  }
  /* every printed position in the cart (screen printing or DTG/DTF), one entry per batch + position */
  function printed(items) {
    var out = [];
    batches(items).forEach(function (b) {
      var gp = b.garment.properties || {};
      b.branding.forEach(function (d) {
        var m = method(d.variant_title);
        if (m !== 'screen' && m !== 'dtf') return;
        var p = d.properties || {}, loc = d.product_title;
        var cw = m === 'screen' ? (parseInt(p['Ink colourways'] || 1, 10) || 1) : 1;
        out.push({ batch: b, line: d, lot: b.lot, loc: loc, file: fileFor(gp, loc), method: m, type: type(d.variant_title), cw: cw,
                   pantones: inkPantones(p['PMS colours'], cw), inkOf: inkOf(p['Ink colours']), colours: colourQty(gp),
                   qty: d.quantity, headwear: /headwear/i.test(b.garment.product_type || '') });
      });
    });
    return out;
  }
  /* screen printing "units": same logo + position + colours + Pantone -> number of garments */
  function units(items, skipLot) {
    var u = {};
    printed(items).forEach(function (x) {
      if (x.method !== 'screen' || !x.file || x.lot === skipLot) return;
      var per = [];
      for (var i = 0; i < x.cw; i++) per.push(0);
      if (x.cw < 2) per[0] = x.qty;
      else Object.keys(x.colours).forEach(function (c) { var k = (x.inkOf[c] || 1) - 1; if (k >= x.cw) k = 0; per[k] += x.colours[c]; });
      per.forEach(function (n, i) {
        var key = unitKey(x.loc, x.file, x.type, x.pantones[i]);
        if (!u[key]) u[key] = { key: key, loc: x.loc, file: x.file, type: x.type, pantone: x.pantones[i], ink: i + 1, qty: 0, lots: [] };
        u[key].qty += n;
        if (u[key].lots.indexOf(x.lot) < 0) u[key].lots.push(x.lot);
      });
    });
    return u;
  }
  /* bulk price: the same logo, at the same size, in the same position is priced on the combined quantity
     (caps/hats/beanies are kept separate from clothing) */
  function priceKey(handle, file, typ, headwear) { return [handle, P(file).toLowerCase(), typ, headwear ? 'hw' : 'cl'].join('|'); }
  function priceGroups(items, skipLot) {
    var g = {};
    batches(items).forEach(function (b) {
      if (b.lot === skipLot) return;
      var gp = b.garment.properties || {}, hw = /headwear/i.test(b.garment.product_type || '');
      b.branding.forEach(function (d) {
        var m = method(d.variant_title);
        if (!m || m === 'other') return;
        var file = fileFor(gp, d.product_title);
        if (!file) return;
        var key = priceKey(d.handle, file, type(d.variant_title), hw);
        if (!g[key]) g[key] = { key: key, handle: d.handle, type: type(d.variant_title), qty: 0, lines: [] };
        g[key].qty += d.quantity;
        g[key].lines.push(d);
      });
    });
    return g;
  }
  window.xoScreen = { norm: norm, method: method, type: type, inkPantones: inkPantones, inkOf: inkOf, unitKey: unitKey,
                      batches: batches, printed: printed, units: units, colourQty: colourQty, fileFor: fileFor,
                      priceKey: priceKey, priceGroups: priceGroups };
})();
